import React from "react";
import "./Setup.css";
import { FiArrowUpRight } from "react-icons/fi";

export default function Setup() {
 const scrollToTop = () => {
    const form = document.getElementById('enquiry-form');
    
    if (form) {
      const formPosition = form.getBoundingClientRect().top + window.pageYOffset;
      const offset = 20; 
      
      window.scrollTo({
        top: formPosition - offset,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  };



  return (
    <div className="setup wrapper">
      <div className="setup-container">
        <h2>
          From setup to launch, our platform automates documentation,
          streamlines deals, and simplifies closures—so you can focus on growing
          revenue.
        </h2>
        <div className="btn">
          <button onClick={scrollToTop}>
            Request a Demo <FiArrowUpRight style={{ marginLeft: "8px" }} />
          </button>
        </div>
      </div>
    </div>
  );
}
